import { cartBus, type CartItem, type SelectedProduct } from "@/event/cartBus";
import { categoryBus } from "@/event/category/categoryBus";
import { categoryIdBus } from "@/event/category/categoryIdBus";
import { languageIdBus } from "@/event/languageIdBus";
import { productBus } from "@/event/product/productBus";
import { quantityBus } from "@/event/product/quantityBus";
import { relatedGroupBus } from "@/event/product/relatedGroupeBus";
import { messageAlertSelectProductHappy, messageAlertSelectProductHappyEmpty } from "@/happyTheme/event/product/messageAlertSelectProductHappy";
import { selectOptionsListHappy } from "@/happyTheme/event/product/selectOptionsListHappy";
import { convertPriceToEuro } from "@/utils/price/convertPrice";
import { getOptionName } from "@/utils/product/getOptionName";
import { getProductName } from "@/utils/product/getProductName";
import { getProductTax } from "@/utils/product/getProductTax";
import { productsSelectedEqual } from "@/utils/product/productSelectedEqual";
import { toggleSelectedModalProductHappy } from "../toggleSelectedModalProductHappy";
import { getOptionValueNameById } from "@/utils/product/getOptionValueNameById";
import { getTotalPriceHappy } from "../getTotalPriceHappy";
import { showAlertValidateProductHappy } from "@/happyTheme/event/product/showAlertValidateProductHappy";
import { productAssociated } from "@/event/product/productAssociated";
import { TimeOutClass } from "@/happyTheme/services/timeout/TimeOutClass";
import { showProductAssociated } from "@/happyTheme/event/product/showProductAssociated";
import { TIME_SHOW_PRODUCT_ASSOCIATED } from "@/happyTheme/config/constants/timeShowProductAssociated";

let idTimeOut: number | ReturnType<typeof setTimeout> = 0

export function addToCartHappy() {
    try {


        const product = productBus.value
        const options = product?.options

        const selectOption = selectOptionsListHappy.value
        const optionMissing: {
            option_name: any
            message: string
            status: string
        }[] = []

        if (!product) return

        if (idTimeOut !== 0) clearTimeout(idTimeOut)

        options?.forEach((o, i) => {
            const maxOptionCount = o.max_option_count
            const freeOptionCount = o.free_option_count
            const optionId = o.option_id

            if (o.required && !relatedGroupBus.value.includes(o.option_id)) {
                const nameOption = getOptionName(o, languageIdBus.value)

                if (o.type === 'radio') {
                    if (!selectOption[optionId]) {
                        optionMissing.push({
                            option_name: nameOption,
                            message: `Une sélection est requise pour cette option !`,
                            status: 'stop'
                        })
                    } else if (selectOption[optionId].selected_values.radio_option.option_value_id === 0) {
                        optionMissing.push({
                            option_name: nameOption,
                            message: `Une sélection est requise pour cette option !`,
                            status: 'stop'
                        })
                    }
                } else {
                    if (!selectOption[optionId]) {
                        optionMissing.push({
                            option_name: nameOption,
                            message: `Une sélection est requise pour cette option !`,
                            status: 'stop'
                        })
                        return
                    }

                    const lengthSelected = [
                        ...selectOption[optionId].selected_values.checkbox_option.option_value_free,
                        ...selectOption[optionId].selected_values.checkbox_option.option_value_paid
                    ].length

                    if (lengthSelected >= 1) {
                        if (freeOptionCount !== 0
                            && maxOptionCount === 0
                            && selectOption[optionId].selected_values.checkbox_option.option_value_free.length < freeOptionCount) {
                            const freeOptionSelected = freeOptionCount - selectOption[o.option_id].selected_values.checkbox_option.option_value_free.length

                            optionMissing.push({
                                option_name: nameOption,
                                message: `Vous pouvez sélectionner encore ${freeOptionSelected} option gratuite ! `,
                                status: 'continue'
                            })
                        } else if (freeOptionCount !== 0
                            && o.max_option_count !== 0
                            && selectOption[optionId].selected_values.checkbox_option.option_value_free.length < o.free_option_count) {
                            const freeOptionSelected = o.free_option_count - selectOption[o.option_id].selected_values.checkbox_option.option_value_free.length

                            optionMissing.push({
                                option_name: nameOption,
                                message: `Vous pouvez sélectionner encore ${freeOptionSelected} option gratuite ! `,
                                status: 'continue'
                            })
                        } else if (freeOptionCount === 0
                            && maxOptionCount === 0
                            && selectOption[optionId].selected_values.checkbox_option.option_value_paid.length < 1) {
                            optionMissing.push({
                                option_name: nameOption,
                                message: `Vous devez sélectionner au moins une option !`,
                                status: 'stop'
                            })
                        }
                        else if (freeOptionCount === 0
                            && maxOptionCount !== 0
                            && selectOption[optionId].selected_values.checkbox_option.option_value_paid.length < 1) {
                            optionMissing.push({
                                option_name: nameOption,
                                message: `Vous devez sélectionner au moins une option !`,
                                status: 'stop'
                            })
                        }
                    } else {
                        optionMissing.push({
                            option_name: nameOption,
                            message: `Une sélection est requise pour cette option !`,
                            status: 'stop'
                        })
                    }
                }


            }
        })

        const hasStop = optionMissing.some(o => o.status === 'stop')

        if (hasStop) {

            messageAlertSelectProductHappy.value = {
                option: optionMissing,
                type: 'error',
                message: '',
                title: "Attention"
            }
            timeOutMessageAlertSelectProductHappy(2500)
            return
        }

        const selectedProducts: SelectedProduct[] = []
        const productName = getProductName(product)

        for (const [key, value] of Object.entries(selectOptionsListHappy.value)) {

            if (value.selected_values.radio_option.option_value_id !== 0) {
                const price = convertPriceToEuro(value.selected_values.radio_option.option_value_price)
                const paid = Number(price) > 0

                const optionFind = product?.options.find((o) => o.option_id === value.option_id)
                const optionValueFind = optionFind?.values.find((ov) => ov.option_value_id === value.selected_values.radio_option.option_value_id)

                if (optionFind && optionValueFind) {
                    const optionValueName = getOptionValueNameById(optionValueFind?.option_value_id, languageIdBus.value)

                    selectedProducts.push({
                        optionName: value.name_option,
                        productName: optionValueName,
                        valueId: value.selected_values.radio_option.option_value_id,
                        option_id: value.option_id,
                        price: value.selected_values.radio_option.option_value_price,
                        paid: paid,
                        sort_order: optionFind?.po_sort_order,
                        type: optionFind?.type,
                        title: optionFind?.title,
                        reset: optionValueFind?.reset,
                        product_option_id: optionFind?.product_option_id
                    })
                }
            }

            if (value.selected_values.checkbox_option.option_value_free.length !== 0) {
                value.selected_values.checkbox_option.option_value_free.forEach((ovf) => {
                    const optionFind = product?.options.find((o) => o.option_id === value.option_id)
                    const optionValueFind = optionFind?.values.find((ov) => ov.option_value_id === ovf.option_value_id)

                    if (optionFind && optionValueFind) {
                        const optionValueName = getOptionValueNameById(optionValueFind?.option_value_id, languageIdBus.value)

                        selectedProducts.push({
                            optionName: value.name_option,
                            productName: optionValueName,
                            valueId: optionValueFind.option_value_id,
                            option_id: value.option_id,
                            price: "0",
                            paid: false,
                            sort_order: optionFind?.po_sort_order,
                            type: optionFind?.type,
                            title: optionFind?.title,
                            reset: optionValueFind?.reset,
                            product_option_id: optionFind?.product_option_id
                        })
                    }
                })
            }

            if (value.selected_values.checkbox_option.option_value_paid.length !== 0) {
                value.selected_values.checkbox_option.option_value_paid.forEach((ovp) => {
                    const optionFind = product?.options.find((o) => o.option_id === value.option_id)
                    const optionValueFind = optionFind?.values.find((ov) => ov.option_value_id === ovp.option_value_id)

                    if (optionFind && optionValueFind) {
                        const optionValueName = getOptionValueNameById(optionValueFind?.option_value_id, languageIdBus.value)

                        selectedProducts.push({
                            optionName: value.name_option,
                            productName: optionValueName,
                            valueId: optionValueFind.option_value_id,
                            option_id: value.option_id,
                            price: ovp.option_value_price,
                            paid: true,
                            sort_order: optionFind?.po_sort_order,
                            type: optionFind?.type,
                            title: optionFind?.title,
                            reset: optionValueFind?.reset,
                            product_option_id: optionFind?.product_option_id
                        })
                    }
                })
            }
        }

        const categorySortOrder = categoryBus.value?.find((c) => c.category_id === product.category_id)
        const totalPrice = getTotalPriceHappy()

        if (!categorySortOrder || !productBus.value) return

        const newProduct: CartItem = {
            category_id: categoryIdBus.value,
            c_sort_order: categorySortOrder.sort_order,
            product_image: product.image,
            product_id: product.product_id,
            product: productName,
            price: Number(product.price),
            total_price: totalPrice,
            price_tax: getProductTax(totalPrice, productBus.value.rate),
            rate_tax: productBus.value.rate,
            quantity: quantityBus.value,
            lbl_printer_id: productBus.value.lbl_printer_id,
            printer_port: 9100,
            printer_id: productBus.value.printer_id,
            product_option: selectedProducts
        }

        const existingProduct = cartBus.value.find((product) =>
            productsSelectedEqual(product, newProduct)
        )

        if (existingProduct) {
            existingProduct.quantity += newProduct.quantity
            existingProduct.total_price += newProduct.total_price
            existingProduct.price_tax += getProductTax(newProduct.total_price, productBus.value.rate)
        } else {
            cartBus.value.push(newProduct)
        }

        if (productAssociated.value.length === 0) {
            showAlertValidateProductHappy.value = true
            const idTimeout = setTimeout(() => {
                toggleSelectedModalProductHappy()
            }, TIME_SHOW_PRODUCT_ASSOCIATED)
            const timeOutClass = TimeOutClass.getInstance()
            timeOutClass.setTimeoutWithKey('addToCartHappy', idTimeout)
        } else {
            showAlertValidateProductHappy.value = true
            const idTimeout = setTimeout(() => {
                showProductAssociated.value = true
            }, TIME_SHOW_PRODUCT_ASSOCIATED)
            const timeOutClass = TimeOutClass.getInstance()
            timeOutClass.setTimeoutWithKey('addToCartHappy', idTimeout)
        }
    } catch (error) {
        console.error("addToCartHappy error : ", error)
    }

}

function timeOutMessageAlertSelectProductHappy(time = 1200) {
    idTimeOut = setTimeout(() => {
        messageAlertSelectProductHappy.value = messageAlertSelectProductHappyEmpty
    }, time)
}